// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sGmh4","italicText":"styles_italicText__PDT6z","vector":"styles_vector__97jDZ"};